import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { atLeastCorePlan } from 'utils/plans'

import { PLAN_TYPES } from 'containers/App/constants'

import CenteredLoader from 'components/lib/CenteredLoader'
import Button from 'components/lib/DesignSystem/Button'

import Modal from '../lib/DesignSystem/Modal'

import FreeTrialModal from './FreeTrialModal'

const LICENCES_VALID_FOR_FREE_TRIAL = [
  PLAN_TYPES.STARTER,
  PLAN_TYPES.CORE,
  PLAN_TYPES.EMAIL_PROTECT,
]

const UpgradeLicenseModal = ({
  opened,
  onClose,
  triggerText,
  triggerTextColor,
  trigger,
  isButton,
  isHideButton,
  buttonSize,
  className,
  id,
  licenses,
  partner,
  companyId,
  companyDomain,
  userEmail,
  getFreeTrialStatus,
  isValid,
  loader,
  message,
  error,
  setFreeTrialStatus,
  success,
  showFreeTrialModalOnOpen,
}) => {
  const [showContactModal, setShowContactModal] = useState(false)
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false)
  const [previewLoader, setPreviewLoader] = useState(false)

  const openModal = () => {
    if (showFreeTrialModalOnOpen && !success) openFreeTrialModal(true)
    else setShowContactModal(true)
  }
  useEffect(() => {
    if (opened) openModal()
  }, [opened])

  const closeModal = () => {
    if (onClose) onClose()

    setShowContactModal(false)
  }

  const handlePreviewLoaded = () => setPreviewLoader(false)

  const getPlanPath = () => {
    if (licenses.plan === PLAN_TYPES.STARTER) return 'starter'
    else if (partner) return 'partner-email-protect'
    else return 'email-protect'
  }

  const planPath = getPlanPath()

  useEffect(() => {
    const validForFreeTrial = LICENCES_VALID_FOR_FREE_TRIAL.includes(licenses.plan)

    if (validForFreeTrial) getFreeTrialStatus()
  }, [getFreeTrialStatus, licenses.plan])

  const currentLicenseName = Object.keys(PLAN_TYPES).find(
    (key) => PLAN_TYPES[key] === licenses.plan
  )

  const iframeSrc =
    `https://ironscales.com/upgrade/${planPath}/?tenant_id_cnc=${companyId}&` +
    `tenant_domain_cnc=${companyDomain}&partner_cnc=${
      partner ? partner.name?.replaceAll(' ', '_') : ''
    }&` +
    `current_license_cnc=${currentLicenseName}&current_url_cnc=${window.location.pathname}&email=${userEmail}`

  const openFreeTrialModal = () => {
    setShowContactModal(false)
    setShowFreeTrialModal(true)
  }

  const closeFreeTrialModal = () => setShowFreeTrialModal(false)

  return (
    <>
      {!opened && !isHideButton && (
        <>
          {isButton ? (
            <Button
              text={triggerText}
              leftIcon="plan-upgrade"
              iconStyle={{ size: '20px' }}
              onClick={openModal}
              styleType="upgrade"
              size={buttonSize}
              id={id}
            />
          ) : (
            <span
              onClick={openModal}
              id={id}
              className="link-color sb cp"
              style={{ color: triggerTextColor }}
            >
              {triggerText || trigger}
            </span>
          )}
        </>
      )}
      <Modal
        open={showContactModal}
        width="calc(100% - 70px)"
        height="calc(100% - 70px)"
        onClose={closeModal}
        id="Upgrade_License_Modal"
        title="Upgrade License"
        footer={
          <Button
            id="Upgrade_Modal_Free_Trial_Open_Modal"
            onClick={openFreeTrialModal}
            styleType="submit"
            text="Upgrade now"
          />
        }
      >
        <>
          {previewLoader && <CenteredLoader overlap overlapMargin={8} />}
          <iframe
            frameBorder="0"
            className={className}
            onLoad={handlePreviewLoaded}
            title="upgrade-license"
            src={iframeSrc}
          />
        </>
      </Modal>
      {showFreeTrialModal && (
        <FreeTrialModal
          success={success}
          onSubmit={setFreeTrialStatus}
          onClose={closeFreeTrialModal}
          isValid={isValid}
          isLoading={loader}
          message={message}
          error={error}
          atLeastCorePlan={atLeastCorePlan(licenses.plan)}
        />
      )}
    </>
  )
}

export default styled(UpgradeLicenseModal)`
  width: 100%;
  height: 100%;
`
